import { Link } from 'react-router-dom';

// media
import horizontalLogoGreenImg from '../../media/horizontal-logo-green.svg';

function SidebarNav(props: {
    children: React.ReactNode[];
}) {
    return (
        <nav className="w-64 bg-white">
            <div className="flex flex-col justify-center items-center sm:h-nav-sm md:h-nav-md lg:h-nav-lg xl:h-nav-xl">
                <Link to="/">
                    <img src={horizontalLogoGreenImg} alt="Acre logo" className={`h-8 md:inline-block hidden`}></img>
                </Link>
            </div>
            { props.children }
        </nav>
    )
}
export default SidebarNav;